import "vant/lib/dialog/style";
import _Dialog from "vant/lib/dialog";
import "vant/lib/toast/style";
import _Toast from "vant/lib/toast";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _Object$keys from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/object/keys";
import _defineProperty from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty";
import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import * as tslib_1 from "tslib";
import { Component, Prop, Vue } from "vue-property-decorator";
import { Action, Mutation } from "vuex-class";
import * as types from "@/store/constants/types";
import Nav from "@/components/nav/navBar.vue";
import purpleButton from "@/components/purpleButton/purpleButton.vue";
import routerTempHelpers from "@/utils/routerTempHelpers";
import { i18n } from "@/i18n/i18n-setup";
var white_key = i18n.t("common.gender.white");
var asian_key = i18n.t("common.gender.asian");
var hispanicOrLatino_key = i18n.t("common.gender.hispanicOrLatino");
var black_key = i18n.t("common.gender.black");

var FutureBabyResult =
/*#__PURE__*/
function (_Vue) {
  _inherits(FutureBabyResult, _Vue);

  function FutureBabyResult() {
    var _this$defaultData;

    var _this;

    _classCallCheck(this, FutureBabyResult);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FutureBabyResult).apply(this, arguments));
    _this.transitionName = "slide-enter-active";
    _this.defaultSex = i18n.t("future_baby.placeholder_gender");
    _this.defaultArea = i18n.t("future_baby.placeholder_ethnicity");
    _this.sexColumns = [i18n.t("common.either"), i18n.t("common.boy"), i18n.t("common.girl")];
    _this.showSexPicker = false;
    _this.showAreaPicker = false;
    _this.defaultData = (_this$defaultData = {}, _defineProperty(_this$defaultData, white_key, [i18n.t("common.gender.caucasian"), i18n.t("common.gender.middle_eastern"), i18n.t("common.gender.north_african")]), _defineProperty(_this$defaultData, asian_key, [i18n.t("common.gender.east_asian"), i18n.t("common.gender.southeast_asian"), i18n.t("common.gender.south_asian")]), _defineProperty(_this$defaultData, hispanicOrLatino_key, [i18n.t("common.gender.hispanic"), i18n.t("common.gender.latino")]), _defineProperty(_this$defaultData, black_key, [i18n.t("common.gender.black")]), _this$defaultData);
    _this.areaColumns = [{
      values: _Object$keys(_this.defaultData),
      className: "column1"
    }, {
      values: _this.defaultData["White"],
      className: "column2",
      defaultIndex: 0
    }];
    _this.placeholder_ethnicity = i18n.t("future_baby.placeholder_ethnicity");
    _this.placeholder_gender = i18n.t("future_baby.placeholder_gender");
    _this.columns = [];
    _this.button_text = i18n.t("get_my_report.button_text");
    return _this;
  }

  _createClass(FutureBabyResult, [{
    key: "showMask",
    value: function showMask(name) {
      if (name === "sex") {
        this.showSexPicker = true;
        this.columns = this.sexColumns;
      } else {
        this.showAreaPicker = true;
        this.columns = this.areaColumns;
      }
    }
  }, {
    key: "goBack",
    value: function goBack() {
      this.routerGoBack(-1);
    }
  }, {
    key: "onChange",
    value: function onChange(picker, values) {
      picker.setColumnValues(1, this.defaultData[values[0]]);
    }
  }, {
    key: "onCancel",
    value: function onCancel() {
      this.showAreaPicker = false;
      this.showSexPicker = false;
    }
  }, {
    key: "onConfirm",
    value: function onConfirm(value, index) {
      if (this.showAreaPicker) {
        this.defaultArea = value[1];
      } else {
        this.defaultSex = value;
      }

      this.onCancel();
    }
  }, {
    key: "getResult",
    value: function () {
      var _getResult = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var result, result_img, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.defaultArea === this.placeholder_ethnicity)) {
                  _context.next = 3;
                  break;
                }

                _Toast(i18n.t("toast.select_ethnicity"));

                return _context.abrupt("return");

              case 3:
                if (!(this.defaultSex === this.placeholder_gender)) {
                  _context.next = 6;
                  break;
                }

                _Toast(i18n.t("toast.select_gender"));

                return _context.abrupt("return");

              case 6:
                _context.prev = 6;
                this.updataLoadingStatus(true);
                _context.next = 10;
                return this.getFutureBabyResult({
                  key: this.resultKey,
                  ethnicity: this.defaultArea,
                  sex: this.defaultSex
                });

              case 10:
                result = _context.sent;

                if (result && result.status === 200) {
                  data = result && result.data && JSON.parse(result.data);

                  if (data && data.code === "0") {
                    result_img = "data:image/jpeg;base64," + data.data.pic;
                  }
                }

                this.routerReplace({
                  name: "futureBabyResult",
                  params: {
                    routerTransition: "forward",
                    showVipRightNow: true
                  },
                  query: {
                    tempKey: routerTempHelpers.setQueryTemp({
                      baby_image: result_img,
                      image_one: this.imageOne,
                      image_two: this.imageTwo
                    })
                  }
                });
                this.updataLoadingStatus(false);
                _context.next = 20;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context["catch"](6);
                this.updataLoadingStatus(false);

                _Dialog.confirm({
                  title: "ERROR",
                  message: "falied",
                  confirmButtonText: "RETRY",
                  cancelButtonText: "CANCEL"
                }).then(function () {
                  _this2.getResult();
                }).catch(function () {
                  _this2.goBack();
                });

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 16]]);
      }));

      function getResult() {
        return _getResult.apply(this, arguments);
      }

      return getResult;
    }()
  }, {
    key: "created",
    value: function created() {
      this.transitionName = "slide-enter-active";
    }
  }, {
    key: "destroyed",
    value: function destroyed() {
      this.transitionName = "slide-leave-active";
    }
  }]);

  return FutureBabyResult;
}(Vue);

tslib_1.__decorate([Action(types.ROUTER_GO_BACK)], FutureBabyResult.prototype, "routerGoBack", void 0);

tslib_1.__decorate([Action(types.GET_FUTURE_BABY_RESULT)], FutureBabyResult.prototype, "getFutureBabyResult", void 0);

tslib_1.__decorate([Action(types.ROUTER_REPLACE)], FutureBabyResult.prototype, "routerReplace", void 0);

tslib_1.__decorate([Mutation(types.UPDATE_LOADING_STATUS)], FutureBabyResult.prototype, "updataLoadingStatus", void 0);

tslib_1.__decorate([Prop({
  default: ""
})], FutureBabyResult.prototype, "resultKey", void 0);

tslib_1.__decorate([Prop({
  default: ""
})], FutureBabyResult.prototype, "imageOne", void 0);

tslib_1.__decorate([Prop({
  default: ""
})], FutureBabyResult.prototype, "imageTwo", void 0);

FutureBabyResult = tslib_1.__decorate([Component({
  components: {
    Nav: Nav,
    purpleButton: purpleButton
  }
})], FutureBabyResult);
export default FutureBabyResult;